import type { PaginatedResponse, Builder } from "../../types.js";
import type { CostCenter } from "./types.js";
import { buildHierarchyEndpoints } from "./hierarchyEndpoints.js";
import { loadAllPages } from "../../utils/loadAllPages.js";
import type {
	FetchBaseQueryError,
	FetchBaseQueryMeta,
	QueryReturnValue,
} from "@reduxjs/toolkit/query";

export const buildCostCenterEndpoints = (builder: Builder) => ({
	...buildHierarchyEndpoints(builder),
	getAllCostCenters: builder.query<
		CostCenter[],
		{ companyDomainId: string; legalEntityId: string }
	>({
		queryFn(
			{ companyDomainId, legalEntityId },
			_api,
			_extraOptions,
			baseQuery,
		) {
			return loadAllPages(({ take, skip }) => {
				return baseQuery({
					url: `/v1/company-domain/${companyDomainId}/legal-entity/${legalEntityId}/cost-center`,
					params: { take, skip },
				}) as Promise<
					QueryReturnValue<
						PaginatedResponse<CostCenter>,
						FetchBaseQueryError,
						FetchBaseQueryMeta
					>
				>;
			});
		},
	}),
});
